/** @jsxRuntime classic */ // <-- remove this when TS updated to 4.1
/** @jsx jsx */ // <-- remove this when TS updated to 4.1
import { jsx } from '@emotion/core';
import { FC, useContext } from 'react';
import { useTheme } from 'emotion-theming';
import { Controller, useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { Button, Form, Input, Page } from '../..';
import { appStore } from '../../../state';
import { Copy, ROUTES, ThemeProps } from '../../../types';
import { isEmpty, isValidEmail } from '../../../utils';
import { useGetPasswordReset } from '../../../hooks';

interface ForgottenPasswordProps extends Copy {}

const ForgottenPassword: FC<ForgottenPasswordProps> = ({
  fallbackCopy,
  localeCopy,
}) => {
  const { dispatch, state } = useContext(appStore);
  const theme: ThemeProps = useTheme();
  const history = useHistory();
  const { form } = state;
  // initialise form
  const { control, errors, getValues, handleSubmit } = useForm({
    defaultValues: {
      emailAddress: form.emailAddress || '',
    },
  });

  const { isLoading, refetch } = useGetPasswordReset({
    dispatch,
    email: getValues().emailAddress,
    queryConfig: {
      enabled: false,
      onError: (error: any) => {
        console.error('Error with forgotten password submission: ', error);
        dispatch({
          type: 'ADD_MESSAGE',
          payload: {
            dismissable: true,
            id: new Date().getTime(),
            text:
              localeCopy?.errors?.GENERIC_ERROR ||
              fallbackCopy.errors.GENERIC_ERROR,
            timeout: 7,
            type: 'error',
          },
        });
      },
      onSuccess: (data: any) => {
        dispatch({
          type: 'ADD_MESSAGE',
          payload: {
            dismissable: true,
            id: new Date().getTime(),
            text: localeCopy?.successMessage || fallbackCopy.successMessage,
            type: 'success',
          },
        });
        history.replace(ROUTES.USER_LOGIN);
      },
    },
  });

  const onSubmit = async (formData: any) => {
    refetch();
  };
  /**
   * Form submit error handler
   */
  const onError = (errors: any) => {
    console.error('Form errors: ', errors);
  };

  return (
    <Page isReady={true} title={localeCopy?.title || fallbackCopy.title}>
      <Form
        disableEnterKeypress={false}
        onSubmit={handleSubmit(onSubmit, onError)}>
        <Controller
          control={control}
          name='emailAddress'
          render={({ name, onChange, value }) => (
            <Input
              errorMessage={errors && errors?.emailAddress?.message}
              isError={!isEmpty(errors?.emailAddress)}
              label={
                localeCopy?.emailAddress?.label ||
                fallbackCopy.emailAddress.label
              }
              name={name}
              onChange={onChange}
              placeholder={
                localeCopy?.emailAddress?.placeholder ||
                fallbackCopy.emailAddress.placeholder
              }
              type='email'
              value={value}
            />
          )}
          rules={{
            required: {
              message:
                localeCopy?.emailAddress?.errorMessage?.required ||
                fallbackCopy.emailAddress.errorMessage.required,
              value: true,
            },
            validate: {
              isValid: (value: string) =>
                isValidEmail(value) ||
                localeCopy?.emailAddress?.errorMessage?.invalid ||
                fallbackCopy.emailAddress.errorMessage.invalid,
            },
          }}
        />
        <Button
          css={{
            marginTop: 40,
            [theme.mq.desktop]: {
              marginTop: 48,
            },
          }}
          isBusy={isLoading}
          isBusyText={
            localeCopy?.components?.button?.loading ||
            fallbackCopy?.components.button.loading
          }
          type='submit'
          variant='primary'>
          {localeCopy?.submitButton || fallbackCopy?.submitButton}
        </Button>
      </Form>
    </Page>
  );
};

export default ForgottenPassword;
